import { createSlice } from "@reduxjs/toolkit";
import { addBillingProvider } from "../action";


interface BillingProvider {
    entityType: string;
    organizationName: string;
    firstName: string;
    lastName: string;
    middleName: string;
    identityInformation: {
        IDType1: string;
        IDNumber1: number;
        IDType2: string;
        IDNumber2: number;
        medicaidProviderNumber: number;
        NPINumber: number;
        providerCommercialNumber: number;
        additionalProviderNumber: number;
        demonstrationProjectIdentifier: string;
    },
    providerAddress: {
        street1: string;
        street2: string;
        city: string;
        state: string;
        zipCode: number;
    },
    contactInformation: {
        name: string;
        phoneNumber: number;
        faxNumber: number;
        email: string;
    },
    additionalContact: {
        addName: string,
        addPhoneNumber: number,
        addFaxNumber: string,
        addEmail: number,
    },
    financialRouting: {
        accountNumber: number;
        bankCode: number;
    }
}

interface BillingProviderState {
    billing: BillingProvider[] | any;
    isLoading: boolean
}

const initialState: BillingProviderState = {
    billing: [],
    isLoading: false
}

export const billingInitialSlice = createSlice({
    name: 'billing',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(addBillingProvider.fulfilled, (state, action) => {
                state.billing = action.payload
                state.isLoading = false
            })
            .addCase(addBillingProvider.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(addBillingProvider.rejected, (state, action) => {
                state.isLoading = false
            })
    }

})

export default billingInitialSlice.reducer